<template>
  <div class="template-config">
    <a-card>
      <!-- 查询区 -->
      <a-form layout="inline" class="search-bar">
        <a-form-item label="模板名称">
          <a-input placeholder="请输入模板名称" style="width: 180px" />
        </a-form-item>
        <a-form-item label="模板类型">
          <a-input placeholder="请输入模板类型" style="width: 180px" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary">查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button>重置</a-button>
        </a-form-item>
      </a-form>
      <!-- tab筛选 -->
      <div class="tab-bar">
        <a-button type="default" :class="{ active: tabKey === 'all' }" @click="tabKey = 'all'">全部</a-button>
        <a-button type="default" :class="{ active: tabKey === 'email' }" @click="tabKey = 'email'">邮件模板</a-button>
        <a-button type="default" :class="{ active: tabKey === 'sms' }" @click="tabKey = 'sms'">短信模板</a-button>
        <a-button type="default" :class="{ active: tabKey === 'wecom' }" @click="tabKey = 'wecom'">企业微信模板</a-button>
        <a-button type="default" :class="{ active: tabKey === 'dingtalk' }" @click="tabKey = 'dingtalk'">钉钉模板</a-button>
      </div>
      <!-- 操作按钮 -->
      <div class="operation-bar" style="margin-bottom: 16px;">
        <a-button type="primary" @click="showDrawer">新建模板</a-button>
      </div>
      <!-- 表格区 -->
      <a-table :columns="columns" :data-source="dataSource" :pagination="false" style="margin-top: 16px;">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <a @click="() => handleEdit(record)" style="margin-right: 8px; color: #1677ff;">编辑</a>
            <a @click="() => handleDelete(record)" style="color: #ff4d4f;">删除</a>
          </template>
        </template>
      </a-table>
      <!-- 分页区 -->
      <div class="pagination-bar">
        <span>共有 {{ dataSource.length }} 条数据</span>
        <a-pagination :total="dataSource.length" :pageSize="10" :current="1" style="margin: 0 16px;" />
        <a-select :value="10" style="width: 90px;">
          <a-select-option :value="10">10条/页</a-select-option>
          <a-select-option :value="20">20条/页</a-select-option>
        </a-select>
      </div>
    </a-card>

    <!-- 新建/编辑模板抽屉 -->
    <a-drawer
      :title="isEdit ? '编辑模板' : '新建模板'"
      :visible="drawerVisible"
      @close="closeDrawer"
      width="600"
    >
      <a-form :model="formState" layout="vertical">
        <a-form-item label="模板名称" required>
          <a-input v-model:value="formState.name" placeholder="请输入模板名称" />
        </a-form-item>
        <a-form-item label="模板类型" required>
          <a-select v-model:value="formState.type" placeholder="请选择模板类型">
            <a-select-option value="email">邮件模板</a-select-option>
            <a-select-option value="sms">短信模板</a-select-option>
            <a-select-option value="wecom">企业微信模板</a-select-option>
            <a-select-option value="dingtalk">钉钉模板</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="模板编码" required>
          <a-input v-model:value="formState.code" placeholder="请输入模板编码" />
        </a-form-item>
        <a-form-item label="模板内容" required>
          <a-textarea v-model:value="formState.content" placeholder="请输入模板内容" :rows="6" />
        </a-form-item>
        <a-form-item label="变量说明">
          <a-textarea v-model:value="formState.variables" placeholder="请输入变量说明，例如：${name}：用户名称" :rows="4" />
        </a-form-item>
      </a-form>
      <div class="drawer-footer" style="position: absolute; bottom: 0; width: 100%; border-top: 1px solid #e8e8e8; padding: 10px 16px; text-align: right; left: 0; background: #fff;">
        <a-space>
          <a-button @click="closeDrawer">取消</a-button>
          <a-button type="primary" @click="handleSubmit">确定</a-button>
        </a-space>
      </div>
    </a-drawer>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'

// 定义数据类型接口
interface TemplateRecord {
  id: number
  type: string
  name: string
  code: string
  content: string
  createTime: string
}

interface FormState {
  name: string
  type: string
  code: string
  content: string
  variables: string
}

const tabKey = ref('all')
const drawerVisible = ref(false)
const isEdit = ref(false)

// 表单数据
const formState = reactive<FormState>({
  name: '',
  type: 'email',
  code: '',
  content: '',
  variables: ''
})

const columns = [
  { title: '序号', dataIndex: 'id', key: 'id' },
  { title: '模板类型', dataIndex: 'type', key: 'type' },
  { title: '模板名称', dataIndex: 'name', key: 'name' },
  { title: '模板编码', dataIndex: 'code', key: 'code' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
  { title: '操作', key: 'action' }
]

const dataSource: TemplateRecord[] = [
  { id: 1, type: '邮件模板', name: '用户注册通知', code: 'EMAIL_REGISTER', content: '尊敬的${name}，您好！感谢您注册我们的服务...', createTime: '2024-01-15 10:00:00' },
  { id: 2, type: '短信模板', name: '验证码通知', code: 'SMS_VERIFY_CODE', content: '您的验证码是${code}，5分钟内有效，请勿泄露给他人。', createTime: '2024-01-16 11:30:00' },
  { id: 3, type: '企业微信模板', name: '告警通知', code: 'WECOM_ALERT', content: '【告警通知】\n设备：${device}\n时间：${time}\n告警内容：${content}', createTime: '2024-01-17 09:15:00' }
]

// 显示抽屉
function showDrawer() {
  isEdit.value = false
  resetForm()
  drawerVisible.value = true
}

// 关闭抽屉
function closeDrawer() {
  drawerVisible.value = false
}

// 重置表单
function resetForm() {
  formState.name = ''
  formState.type = 'email'
  formState.code = ''
  formState.content = ''
  formState.variables = ''
}

// 编辑模板
function handleEdit(record: TemplateRecord) {
  isEdit.value = true
  formState.name = record.name
  formState.type = record.type === '邮件模板' ? 'email' : 
                  record.type === '短信模板' ? 'sms' : 
                  record.type === '企业微信模板' ? 'wecom' : 'dingtalk'
  formState.code = record.code
  formState.content = record.content
  formState.variables = ''
  drawerVisible.value = true
}

// 删除模板
function handleDelete(record: TemplateRecord) {
  // 实际项目中应该调用API删除数据
  console.log('删除模板', record)
}

// 提交表单
function handleSubmit() {
  // 实际项目中应该调用API保存数据
  console.log('提交表单', formState)
  drawerVisible.value = false
}
</script>

<style lang="less" scoped>
.template-config {
  .search-bar {
    margin-bottom: 12px;
  }
  .tab-bar {
    margin-bottom: 12px;
    display: flex;
    gap: 8px;
    .active {
      color: #1677ff;
      background: #e6f7ff;
      border-color: #91d5ff;
    }
  }
  .pagination-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
  }
}
</style>